import { ConfigProvider, Spin } from 'antd';
import React, { useContext, useEffect } from 'react';
import { Route, useLocation } from 'react-router-dom';
import { Context } from '../MunicipalNoticeBoard';
import { PVDocumentList } from './DocumentList';
import { PVFolderList } from './FolderList';
import './style.scss';

export const PublicViewContainer = () => {
    const ctx = useContext(Context);
    console.log(ctx);
    const styleFontFamily: any = {};
    if (ctx.font) {
        styleFontFamily.fontFamily = ctx.font;
    }

    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    if (ctx.mainFolder) {
        return (
            <div className="public-view-app" style={styleFontFamily}>
                <ConfigProvider
                    theme={{
                        token: styleFontFamily,
                    }}>
                    <Route exact path="/">
                        <PVFolderList />
                    </Route>
                    <Route exact path="/folder">
                        <PVDocumentList />
                    </Route>
                </ConfigProvider>
            </div>
        );
    }
    return <Spin />;
};
